import { EmptyStateRoot } from "../../empty-state";
import { EmptyStateAction } from "../view-action";
import { EmptyStateDescription } from "../view-description";
import { EmptyStateIllustration } from "../view-illustration";
import { EmptyStateTitle } from "../view-title";
import type { ListEmptyStateViewModel } from "./types-list";

export function ListEmptyStateView({
  illustration,
  title,
  description,
  clearLabel,
  onClear,
  clearTestId,
  testId,
  className,
  classNames,
  rest,
}: ListEmptyStateViewModel) {
  return (
    <EmptyStateRoot testId={testId} className={className} classNames={classNames} {...rest}>
      <EmptyStateIllustration name={illustration} />
      <EmptyStateTitle>{title}</EmptyStateTitle>
      <EmptyStateDescription>{description}</EmptyStateDescription>
      {clearLabel ? (
        <EmptyStateAction
          label={clearLabel}
          onClick={onClear}
          {...(clearTestId ? { "data-testid": clearTestId } : {})}
        />
      ) : null}
    </EmptyStateRoot>
  );
}
